<div id="snackbar" class="snackbar">
    <div class="snackbar-msg-container">
        <img [src]="'images/' + type + '_snackbar_icon.svg'" alt="image" />
        <p>
            {{ message | translate }}
        </p>
    </div>
</div>
